

























import { Component, Prop, Vue  } from 'vue-property-decorator';
@Component
export default class postSelected extends Vue {
    // 商品列表
    goodsList = []
    // 获取商品列表时传入的参数
    params: any = {
        listingTypes:'',
        resultType: 'list',
    }
    created(){
        this.params.listingTypes = this.$route.params.listingTypes || '112' 
        this.getList();
    }
    // 分页信息
    page = { total: 0, pageSize: 20, pageNum: 1 }
    getList() {
        this.fetch({
            url: window.apis.goodsList,
            data: this.params
        }).then((data: any) => {
            console.log(data)
            //整理列表数据 初始化taginfo
            data.list.forEach((item: any) => {
                item.tagInfo = item.tagInfo?item.tagInfo:{}
                // 初始化起订量
                item.goodsNum = item.beginNum = item.tagInfo.beginNum ? item.tagInfo.beginNum: 1;
                // 初始化限购数量
                item.limitNum = item.tagInfo.limitNum ? item.tagInfo.limitNum : 999999; 
            })
            this.goodsList = data.list;
            this.page.total = data.total;
        })
    }
    currentChange(page: number) {
        this.page.pageNum = page
        this.getList()
    }
    goDetai(listId:Number){
        let url=this.$router.resolve({
            path:`/vi/${listId}`
        });
        window.open(url.href,'_blank')
    }
    // 进入购物车
    goCart() {
        this.$router.push("/cart")
    }
}
